export default __webpack_public_path__ + "static/media/icon-games.c2b915bc.svg";